export const ActionTypes = {
  CHANGE_ROLE: "1",
  RESEND_INVITATION: "2",
  REMOVE_INVITATION: "3",
  REMOVE_USER: "4",
  ACTIVATE_USER: "5",
  DEACTIVATE_USER: "6",
};

export enum OrganizationRoles {
  OWNER = 1,
  EDITOR = 2,
  VIEWER = 3,
  CONTRIBUTOR = 4,
}

export enum ProjectRoles {
  OWNER = 1,
  EDITOR = 2,
  VIEWER = 3,
  CONTRIBUTOR = 4,
  TAGGER = 5,
}

export const SensorLayouts = [
  {
    value: "systematic_random",
    name: "Systematic Random",
  },
  {
    value: "simple_random",
    name: "Simple Random",
  },
  {
    value: "clustered_random",
    name: "Clustered Random",
  },
  {
    value: "experimental",
    name: "Experimental",
  },
  {
    value: "opportunistic",
    name: "Opportunistic",
  },
  {
    value: "targeted",
    name: "Targeted",
  },
];

export const CaptureMethod = [
  {
    value: "activity_detection",
    name: "Activity Detection (Sense Detection)",
  },
  {
    value: "time_lapse",
    name: "Time Lapse",
  },
  {
    value: "both",
    name: "Both",
  },
];

export const YesSomeNo = [
  {
    value: "yes",
    name: "Yes",
  },
  {
    value: "some",
    name: "Some",
  },
  {
    value: "no",
    name: "No",
  },
];

export const YesNo = [
  {
    value: "yes",
    name: "Yes",
  },
  {
    value: "no",
    name: "No",
  },
];

export const BaitType = [
  {
    value: "scent",
    name: "Scent",
  },
  {
    value: "meat",
    name: "Meat",
  },
  {
    value: "visual",
    name: "Visual",
  },
  {
    value: "acoustic",
    name: "Acoustic",
  },
  {
    value: "other",
    name: "Other",
  },
];

export const PhotosLicense = [
  {
    value: "cc0",
    name: "CC0",
  },
  {
    value: "cc_by_4",
    name: "CC BY 4.0",
  },
  {
    value: "cc_by_nc",
    name: "CC BY-NC",
  },
];

export const MetadataLicense = [
  {
    value: "cc0",
    name: "CC0",
  },
  {
    value: "cc_by_4",
    name: "CC BY 4.0",
  },
];

export const FeatureTypes = [
  {
    name: "Burrow",
    value: "burrow",
  },
  {
    name: "Carcass",
    value: "carcass",
  },
  {
    name: "Culvert",
    value: "culvert",
  },
  {
    name: "Fruiting tree",
    value: "fruiting_tree",
  },
  {
    name: "Nest site",
    value: "nest_site",
  },
  {
    name: "Road bridge",
    value: "road_bridge",
  },
  {
    name: "Road dirt",
    value: "road_dirt",
  },
  {
    name: "Road overpass",
    value: "road_overpass",
  },
  {
    name: "Road paved",
    value: "road_paved",
  },
  {
    name: "Road underpass",
    value: "road_underpass",
  },
  {
    name: "Trail game",
    value: "trail_game",
  },
  {
    name: "Trail hiking",
    value: "trail_hiking",
  },
  {
    name: "Water source",
    value: "water_source",
  },
  {
    name: "Other",
    value: "other",
  },
  {
    name: "None",
    value: "none",
  },
];

export const CameraStatus = [
  {
    name: "Camera functioning",
    value: "camera_functioning",
  },
  {
    name: "Camera hardware failure",
    value: "camera_hardware_failure",
  },
  {
    name: "Film failure",
    value: "film_failure",
  },
  {
    name: "Memory card",
    value: "memory_card",
  },
  {
    name: "Theft",
    value: "theft",
  },
  {
    name: "Unknown failure",
    value: "unknown_failure",
  },
  {
    name: "Vandalism",
    value: "vandalism",
  },
  {
    name: "Wildlife damage",
    value: "wildlife_damage",
  },
];

export const CameraHeight = [
  {
    name: "Chest height",
    value: "chest_height",
  },
  {
    name: "Knee height",
    value: "knee_height",
  },
  {
    name: "Canopy",
    value: "canopy",
  },
  {
    name: "Unknown",
    value: "unknown",
  },
  {
    name: "Other",
    value: "other",
  },
];

export const CameraAngle = [
  {
    name: "Parallel",
    value: "parallel",
  },
  {
    name: "Pointed downward",
    value: "pointed_downward",
  },
  {
    name: "Varies",
    value: "varies",
  },
  {
    name: "Unknown",
    value: "unknown",
  },
  {
    name: "Other",
    value: "other",
  },
];
